import type { Ctx } from "../types";
import { Action, setQueryParams } from "gg-wf-scripts";

export const toggle_table_sort: Action<Ctx, { key: string }> = (
  _ctx,
  data,
  params
) => {
  const { key } = data;
  const currentSortBy = params.get("sortBy");
  const currentSortDir = params.get("sortDir");

  if (currentSortBy !== key || currentSortDir !== "asc") {
    setQueryParams([
      { key: "sortBy", value: key },
      { key: "sortDir", value: "asc" },
    ]);
  } else {
    setQueryParams([{ key: "sortDir", value: "desc" }]);
  }

  return { ok: true };
};
